import axios from 'axios'
import { useEffect, useState } from 'react'

type Props = {
  animations: { path: string; key: string }[]
}

const useLoadAnimations = (props: Props) => {
  const [animations, setAnimations] = useState<{
    [key in Props['animations'][number]['key']]: null | Object
  }>({})

  useEffect(() => {
    const fetchAnimations = async () => {
      for (const animation of props.animations) {
        const res = await axios.get(animation.path)
        setAnimations((prev) => ({ ...prev, [animation.key]: res.data }))
      }
    }
    fetchAnimations()
  }, [])

  return { animations }
}

export default useLoadAnimations
